module.exports = __webpack_public_path__ + "static/media/screen3.d142f544.png";